import styled from "styled-components";
import media from "constants/media";
import Description from "components/shared/hero/description/Description";

export const PrivacyStyled = styled.div`
    background: var(--color-darkNight);
`;

export const HeroText = styled(Description)`
    font-size: 14px;
    line-height: 20px;

    ${media.mdUp`
        font-size: 16px;
        line-height: 25px;
    `}
`;

export const Content = styled.div`
    position: relative;
    z-index: 2;

    margin: 0 -10px;
    padding: 50px 20px;

    background-color: var(--color-white);

    a {
        margin-top: 20px;
    }

    ${media.mdUp`
        max-width: 780px;
        margin: 0 auto 130px;
        padding: 40px;    
        
        box-shadow: 10px 10px 24px 0 rgba(0, 23, 75, 0.05);
    `}
`;

export const Image = styled.div`
    position: absolute;
    top: -110px;
    left: -125px;
    z-index: 1;

    width: 1484px;
    height: 727px;

    background: url("/images/saldocheck-letters-desktop.svg") no-repeat top
        center;

    ${media.desktopOnly}
`;
